import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-printing',
  templateUrl: './help-printing.component.html'
})
export class HelpPrintingComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
    
  }
  printing_heading;
  printing_desc;
  printing_para1heading;
  printing_para1body;
  printing_para2heading;
  printing_para2body;
  printing_para3heading;
  printing_para3body;
  printing_para4heading;
  printing_para4body;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
    
    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.getprintinglabels();
  }
  getprintinglabels() {
    this.graphQlService.gethelpprintingLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.printing_heading = labels.filter(x => x.key == "printing_heading").map(y => y.value);
        this.printing_desc = labels.filter(x => x.key == "printing_desc").map(y => y.value);
        this.printing_para1heading = labels.filter(x => x.key == "printing_para1heading").map(y => y.value);
        this.printing_para1body = labels.filter(x => x.key == "printing_para1body").map(y => y.value);
        this.printing_para2heading = labels.filter(x => x.key == "printing_para2heading").map(y => y.value);
        this.printing_para2body = labels.filter(x => x.key == "printing_para2body").map(y => y.value);
        this.printing_para3heading = labels.filter(x => x.key == "printing_para3heading").map(y => y.value);
        this.printing_para3body = labels.filter(x => x.key == "printing_para3body").map(y => y.value);
        this.printing_para4heading = labels.filter(x => x.key == "printing_para4heading").map(y => y.value);
        this.printing_para4body = labels.filter(x => x.key == "printing_para4body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });



  }
}
